 
<template>
  <grid-table :columns="columns" :queryParams="queryParams" :url="url" ref="table">
    <span slot="devSlot" slot-scope="text, record">
      <a-tag :key="index" v-for="(item, index) in record.devid_dictText.split(',')">{{ item }}</a-tag>
    </span>
    <span slot="needSlot" slot-scope="text, record">
      <a-tag color="#ff4d4f" v-if="record.needSwitch == 1">需要切换</a-tag>
      <a-tag color="#52c41a" v-else>无需切换</a-tag>
    </span>
  </grid-table>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GridTable from "./Itable";

  export default {
    name: 'PanelTwo',
    components: {
      GridTable
    },
    // 定义属性
    data () {
      return {
        url: '/maintenance/devSwitch/list',
        queryParams: {
          needSwitch: '1',
        },
        columns: [
          {
            title: '设备',
            align: "center",
            dataIndex: 'devid_dictText',
            scopedSlots: { customRender: 'devSlot' },
            width: '25%',
          },
          {
            title: '设备组位号',
            align: "center",
            dataIndex: 'groupTag',
            sorter: true,
          },
          {
            title: '设备组名称',
            align: "center",
            dataIndex: 'groupName',
            sorter: true,
          },
          {
            title: '需要切换',
            align: "center",
            dataIndex: 'needSwitch',
            scopedSlots: { customRender: 'needSlot' },
            sorter: true,
          },
          {
            title: '建议',
            align: "center",
            dataIndex: 'needSwitchContent',
            width: 220,
          }
        ],
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      queryData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style lang='scss' scoped>


</style>